<div id="container">
    <aside class="sidebar lft">
        <a href="#" id="hamburger" title="{{ 'common.menu' | translate }}" class="mobi">
            <span class="burger">
                <i class="top"></i>
                <i class="middle"></i>
                <i class="bottom"></i>
            </span>
            <span class="text">{{ 'common.menu' | translate }}</span>
        </a>

        <app-menu activeElement="downloads"></app-menu>
    </aside>
    <div id="inner">
        <main class="page">
            <div class="page-card">
                <h1>{{ 'screens.downloads.title' | translate }}</h1>

                <section>
                    <h2>{{ 'screens.downloads.energyReport.title' | translate }}</h2>
                    <p>{{ 'screens.downloads.energyReport.description' | translate }}</p>

                    <div class="action-group">
                        <button
                            class="iona-button orange"
                            (click)="openEnergyReport()"
                            [disabled]="isEnergyReportLoading">
                            <i *ngIf="isEnergyReportLoading" class="spinner-sm white m-r-s"></i>
                            {{ 'screens.downloads.energyReport.openButton' | translate }}
                        </button>
                    </div>
                </section>

                <section>
                    <h2>{{ 'screens.downloads.export.title' | translate }}</h2>
                    <p>{{ 'screens.downloads.export.description' | translate }}</p>

                    <div class="export-controls">
                        <div class="action-group">
                            <button
                                class="iona-button orange"
                                (click)="exportConsumptionData()"
                                [disabled]="isExportLoading || !selectedMonth">
                                <i class="download-sm white m-r-s" *ngIf="!isExportLoading"></i>
                                <i class="spinner-sm white m-r-s" *ngIf="isExportLoading"></i>
                                {{ 'screens.downloads.export.downloadButton' | translate }}
                            </button>
                        </div>

                        <div class="month-selector">
                            <select class="iona-select medium" [style.width.%]="100"
                                    [(ngModel)]="selectedMonth">
                                <option *ngFor="let month of availableMonths" [value]="month.value">
                                    {{ month.label }}
                                </option>
                            </select>
                            <span></span>
                        </div>
                    </div>
                </section>

                <section>
                    <h2>{{ 'screens.downloads.exportToThirdParties.title' | translate }}</h2>
                    <p>
                        {{ 'screens.downloads.exportToThirdParties.description' | translate }}
                        <a href="https://www.iona-energy.com" target="_blank" rel="noopener noreferrer">
                            {{ 'screens.downloads.exportToThirdParties.descriptionLink' | translate }}
                        </a>.
                    </p>

                    <div class="action-group">
                        <button
                            class="iona-button orange"
                            (click)="exportToThirdParties()"
                            [disabled]="isThirdPartyExportLoading">
                            <i *ngIf="isThirdPartyExportLoading" class="spinner-sm"></i>
                            {{ 'screens.downloads.exportToThirdParties.button' | translate }}
                        </button>
                    </div>
                </section>

                <section>
                    <h2>{{ 'screens.downloads.gdprExport.title' | translate }}</h2>
                    <p>{{ 'screens.downloads.gdprExport.description' | translate }}</p>

                    <div class="action-group">
                        <button
                            class="iona-button orange"
                            (click)="exportGdprData()"
                            [disabled]="isGdprExportLoading">
                            <i *ngIf="isGdprExportLoading" class="spinner-sm"></i>
                            {{ 'screens.downloads.gdprExport.button' | translate }}
                        </button>
                    </div>
                </section>

                <section>
                    <h2>{{ 'screens.downloads.transparencyDeclaration.title' | translate }}</h2>
                    <p>
                        {{ 'screens.downloads.transparencyDeclaration.description' | translate }}
                        <a href="https://www.enviam.de/Media/docs/default-source/iona-app/date-act-transparenzerkl%C3%A4rung-f%C3%BCr-iona_220925.pdf?sfvrsn=adba169e_3" target="_blank" rel="noopener noreferrer">
                            {{ 'screens.downloads.transparencyDeclaration.descriptionLink' | translate }}
                        </a>.
                    </p>
                </section>
            </div>
        </main>
    </div>
</div>
